import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import * as UsersApi from '@Modules/admin/users/api/UsersApi';
import ChangePasswordMeta from './ChangePasswordFormMeta';
import React from 'react';
import ChangePasswordUI from '@Modules/home/components/forms/ChangePasswordUI';

export default function ChangePasswordFormHandle() {
  const formUIRef = React.useRef<any>(null);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

  const toast = useToast();
  const { isLoading, mutate } = useMutation(UsersApi.createProfile, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Votre mot de pass a été changé',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      console.log('Error: ', error);
    },
  });

  const onSubmit = (payload: any) => {
    console.log('payload: ', payload);
    setIsSubmitting(true);
    // console.log('payload: ', payload);
    setTimeout(() => {
      mutate(payload);
      setIsSubmitting(false);
      formUIRef?.current?.reset();
    }, 2000);
  };

  return (
    <>
      <ChangePasswordUI
        ref={formUIRef}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
        meta={ChangePasswordMeta}
        onSubmit={onSubmit}
      />
    </>
  );
}
